module.exports = __webpack_public_path__ + "img/category-brand.382020e1.png";